export default __webpack_public_path__ + "e01f95b.png";